module.exports = __webpack_public_path__ + "static/media/SVGLinkedIn.ac09aacc.svg";